import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { getEnv } from "./environment";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import axios from "axios";

const env = getEnv();

const pca = new PublicClientApplication({
  auth: {
    clientId: env.auth_client_id,
    authority: env.authority,
    redirectUri: "/",
    postLogoutRedirectUri: "/",
  },
});

//Default to using the first account if no account is active on page load
if (!pca.getActiveAccount() && pca.getAllAccounts().length > 0) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  pca.setActiveAccount(pca.getAllAccounts()[0]);
}

//Optional - This will update account state if a user signs in from another tab or window
pca.enableAccountStorageEvents();

pca.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account;
    pca.setActiveAccount(account);
  }
});

const getPCA = () => {
  return pca;
};

const fetchWithToken = async (url, method = "GET", fetchBody = null) => {
  const auth = await pca.acquireTokenSilent({
    scopes: [env.auth_scope],
  });
  const baseURL = env.url;

  console.log(
    "url: ",
    baseURL + url,
    " fetchBody: ",
    fetchBody,
    " method: ",
    method
  );

  return fetch(baseURL + url, {
    method: method,
    headers: {
      Authorization: `Bearer ${auth.accessToken}`,
      "Content-Type": "application/json",
    },
    body: fetchBody ? JSON.stringify(fetchBody) : null,
  });
};

export { getPCA, fetchWithToken };
